import { enumToOptions } from '@libs/types/src/common/enum/util';
import { ServiceGroupTypeEnum } from '@libs/types/src/services/enum/service-group-type.enum';

export enum CalendarViewTypeEnum {
    BASE = 'base',
    USER = 'user',
    PERSON = 'person',
    FOLDER = 'folder',
    GROUP = ServiceGroupTypeEnum.GROUP,
    SHIFT = ServiceGroupTypeEnum.SHIFT,
    FLOOR = ServiceGroupTypeEnum.FLOOR,
    ROUTE = ServiceGroupTypeEnum.ROUTE,
    ROOM = ServiceGroupTypeEnum.ROOM,
}

export function calendarViewTypeToServiceGroupType(viewType: string): ServiceGroupTypeEnum | null {
    return Object.values(ServiceGroupTypeEnum).find(type => type === viewType) ?? null;
}

export const calendarViewTypeOptions = enumToOptions(CalendarViewTypeEnum, 'calendar.filter.viewTypes.');

export enum ServiceSettingsCalendarSlotDuration {
    HOUR = 'hour',
    MINUTES_15 = 'minutes15',
}

export const serviceSettingsCalendarSlotDurationOptions = enumToOptions(
    ServiceSettingsCalendarSlotDuration,
    'service.settings.calendar.slotDurationOptions.',
);

export enum ServiceSettingsCalendarTimeFormat {
    HOURS_12 = '12',
    HOURS_24 = '24',
}

export const serviceSettingsCalendarTimeFormatOptions = enumToOptions(
    ServiceSettingsCalendarTimeFormat,
    'service.settings.calendar.timeFormatOptions.',
);
